import NavbarContentItem from '../../NavbarContentItem';

import * as S from '../../styles';

type ProductsTab = {
  svg: string;
  links: unknown;
};
interface PropsActiveTab {
  isActive: boolean;
  newsTabProducts: ProductsTab;
  setOpen: (boolean) => void;
  setOption: (boolean) => void;
}
export default function ProductsTab({ isActive, newsTabProducts, setOpen, setOption }: PropsActiveTab) {
  return (
    <S.ListNavbar className={isActive && 'show'}>
      <S.ListTitle>PRODUTOS</S.ListTitle>
      {Object.entries(newsTabProducts.links).map(link => (
        <NavbarContentItem link={link} setOpen={x => setOpen(x)} setOption={x => setOption(x)} key={link[0]} />
      ))}
    </S.ListNavbar>
  );
}
